<template>
<div>
  <div class="split-area-container"
  :style="areaStyle"
  >
    <graphicTitleBar
      :titleData="data"
      @moduleMargeType="false"
    />
    <div class="split-area-left-cont">
      <van-swipe
      :autoplay="specialData.leftSwiperSpeed?specialData.leftSwiperSpeed:autoplay"
      :stop-propagation="stopPropagation"
      indicator-color="white">
        <van-swipe-item
        v-for="(item, index) in specialLeftData"
        :key="index"
        :style="imgStyle">
          <a @click="jumpUrl(item)">
            <img v-if="item.entryImg" :src="item.entryImg" class="img-main" :alt="item.titleName">
            <img v-else :src="defaultImg" class="img-main" :alt="item.titleName">
            <h3 class="carousel-title" v-if="specialData.gridShowTitle && item.titleName">{{item.titleName}}</h3>
            <img class="play-btn" :src="playBtn" alt="" v-if="item.fileType == 2 || item.selectType == 2">
          </a>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="split-area-right-cont flex">
      <div class="split-item-cont"
        v-for="(item, index) in specialRightData"
        :key="index"
        :style="imgStyle">
        <a @click="jumpUrl(item)" class="item-link">
          <img v-if="item.entryImg" :src="item.entryImg" class="img-main" :alt="item.titleName">
          <img v-else :src="defaultImg" class="img-main" :alt="item.titleName">
          <h3 class="carousel-title" v-if="specialData.gridShowTitle && item.titleName">{{item.titleName}}</h3>
          <img class="play-btn" :src="playBtn" alt="" v-if="item.fileType == 2 || item.selectType == 2">
        </a>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import defaultImg from '../asset/images/default-img.png'
import playBtn from '../asset/images/play-btn.png'
import {commonClickFn} from './clickJs'
export default {
  name: "carouselGrid",
  components:{
    graphicTitleBar: ()=>import('./graphicComponent/graphicTitleBar.vue'),

  },
  data() {
    const { tempData: { specialData, specialStyle, specialLeftData, specialRightData }, terminal } = this.data
    return {
      playBtn,
      defaultImg,
      autoplay: 5000,
      stopPropagation: false,//阻止滑动跳转
      specialData,
      specialStyle,
      specialLeftData,
      specialRightData,
      terminal,
    }
  },
  mounted() {
    this.getImageInfoList(this.specialLeftData)
    this.getImageInfoList(this.specialRightData)

    console.log('转化后的数组left',this.specialLeftData)
    console.log('转化后的数组right',this.specialRightData)

  },
  props: {
    data: {
      type: Object
    },
  },
  computed: {
    areaStyle(){
      const {
        blockMargeTop,
        blockMargeBottom,
        blockBGClolor
      } =  this.specialStyle;
      return {
        marginTop: `${blockMargeTop?blockMargeTop:0}px`,
        marginBottom: `${blockMargeBottom?blockMargeBottom:0}px`,
        backgroundColor: blockBGClolor?blockBGClolor:'none',
      }
    },
    imgStyle(){
      const {
        imgRadius=false,
        imgShadow=false,
        imgBorder=false,
        // imgBorderColor='#D6DEEA',
        imgBackgroundColor='#fff',
      } =  this.specialStyle;
      return {
        backgroundColor: imgBackgroundColor?imgBackgroundColor:'',
        borderRadius: imgRadius?'4px':'',
        boxShadow: imgShadow?'0px 0px 8px 0px rgba(0, 0, 0, 0.1)':'',
        border: imgBorder?`1px solid #D6DEEA`:'none'
      }
    }
  },
  methods: {
    //跳转
    jumpUrl(item){
      commonClickFn(item,this.specialData,this,true)
    },
    // 数组处理 通过图片id 视频id 请求最新的图片地址 视频地址
    getImageInfoList(articleDataList){
      let idList = []
      articleDataList.map((item)=>{
        idList.push(item.fileId)
      })
      console.log(idList,'fsdfasdfasdf')
      this.$apis.cms.getImageList(idList).then(res=>{
        let ImageInfoList = res.data
        articleDataList.map((item,index)=>{
          ImageInfoList[index]&&(item.entryImg = ImageInfoList[index].thumbnail)
        })
      })
    }
  }
};
</script>
<style lang="less" scoped>

.split-area-container{
  margin: 24px;
  display: flex;
  flex-direction: column;
  /deep/ .van-swipe__indicators{
    left: 90%!important;
  }
  /deep/ .van-swipe{
    height: 263px;
  }
  .split-area-left-cont{
    .play-btn{
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 112px;
      height: 112px;
    }
  }
  .img-main{
    width: 100%;
    height: 100%;
  }
  .carousel-title {
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
    color: #fff;
    font-size: 32px;
    opacity: 0.75;
    margin: 0;
    font-family: PingFangSC-Regular, PingFang SC;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 64px;
    line-height: 64px;
    background: rgba(0, 0, 0, 0.7);
    padding: 0 12px;
    box-sizing: border-box;
    text-align: left;
    word-break: break-all;
  }
  .video-wrap{
    width: 100%;
    height: 100%;
  }
  .split-area-right-cont{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .split-item-cont{
    position: relative;
    width: 340px;
    height: 254px;
    box-sizing: border-box;
    margin-top: 24px;
    border: 1px solid #D6DEEA;
    .carousel-title{
      font-size: 14px;
      height: 48px;
      line-height: 48px;
    }
    .play-btn{
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 80px;
      height: 80px;
    }
  }
  .item-link{
    position: relative;
    display: block;
    height: 100%;
  }
}
</style>
